module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "el-radio-button",
    class: [
      _vm.size ? 'el-radio-button-' + _vm.size : '',
      {
        'is-active': _vm.value === _vm.label
      }
    ]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "el-radio-button-orig-radio",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm.value, _vm.label)
    },
    on: {
      "change": function($event) {
        _vm.value = _vm.label
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-radio-button-inner",
    style: (_vm.value === _vm.label ? _vm.activeStyle : null)
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-65519260!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/src/radio-button.vue
// module id = 659
// module chunks = 0